export const SET_LOADED_PAGE_PARAMS = (state, loaded) => {
  state.loadedPageParams = loaded;
};

export const SET_LOADING = (state, loading) => {
  state.loading = loading;
};

export const SET_LOADING_TEXT = (state, loadingText) =>
  (state.loadingText = loadingText);

export const SET_LOADING_ANIMATION_ACTIVE = (state, active) =>
  (state.loadingAnimationActive = active);

export const RESET_LOADING = state => {
  state.loading = false;
  state.loadingText = "";
};

export const SET_POST_LOADING_TEXT = (state, postLoadingText) =>
  (state.postLoadingText = postLoadingText);

export const SET_POST_LOADING_ANIMATION_SIZE_FOUND = state =>
  (state.postLoadingAnimation = "sizefound_animation");

export const SET_POST_LOADING_ANIMATION_SIZE_NOT_FOUND = state =>
  (state.postLoadingAnimation = "sizenotfound_animation");

export const SET_POST_LOADING_ANIMATION_ACTIVE = (state, active) =>
  (state.postLoadingAnimationActive = active);

export const RESET_POST_LOADING = state => {
  state.postLoadingText = "";
  state.postLoadingAnimation = "";
};

export const SET_UI_HEADER_TEXT = (state, uiHeaderText) =>
  (state.uiHeaderText = uiHeaderText);

export const SET_UI_HEADER_BACK_ACTIVE = (state, active) =>
  (state.uiHeaderBackActive = active);
